import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronDown } from 'react-icons/fa';
import { usePageData } from '../../contexts/DataContext';
import LoadingSpinner, { LoadingSkeleton } from '../common/LoadingSpinner';

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const { data: homePage, isLoading, error } = usePageData('homePage');

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (isLoading) {
    return (
      <section className="faq-section">
        <div className="container">
          <LoadingSkeleton type="text" count={2} />
          {[...Array(4)].map((_, i) => (
            <div className="faq" key={i}>
              <LoadingSkeleton type="text" count={2} />
            </div>
          ))}
          <div className="support">
            <LoadingSkeleton type="text" count={3} />
          </div>
        </div>
      </section>
    );
  }

  if (error || !homePage || !homePage.faqs) {
    return (
      <section className="faq-section">
        <div className="container">
          <h2><span>Frequently</span> asked Questions</h2>
          <p className="subtitle">Find quick answers to common questions about our tools and services</p>

          {[1, 2, 3, 4].map((i) => (
            <div className="faq" key={i}>
              <div className="faq-header">
                <span>FAQ Question {i}?</span>
                <FaChevronDown className="icon" />
              </div>
              <div className="faq-content">
                <p>FAQ Answer {i} goes here.</p>
              </div>
            </div>
          ))}

          <div className="divider"></div>

          <div className="support">
            <h3>Still need any help?</h3>
            <p>Can't find what you're looking for? Our support team is ready to assist you.</p>
            <Link to="/contact">
              <button>Contact Support</button>
            </Link>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="faq-section">
      <div className="container">
        <h2>{homePage.faq_title}</h2>
        <p className="subtitle">{homePage.faq_subtitle}</p>

        {homePage.faqs.map((faq, index) => (
          <div 
            className={`faq ${activeIndex === index ? 'active' : ''}`} 
            key={index}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-header">
              <span>{faq.question}</span>
              <FaChevronDown className={`icon ${activeIndex === index ? 'rotated' : ''}`} />
            </div>
            <div className="faq-content">
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}

        <div className="divider"></div>

        <div className="support">
          <h3>{homePage.support_title}</h3>
          <p>{homePage.support_text}</p>
          <Link to="/contact">
            <button>{homePage.support_button_text}</button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;